import { render, staticRenderFns } from "./StoryLayout.vue?vue&type=template&id=309477f2&scoped=true&"
import script from "./StoryLayout.vue?vue&type=script&lang=js&"
export * from "./StoryLayout.vue?vue&type=script&lang=js&"
import style0 from "./StoryLayout.vue?vue&type=style&index=0&id=309477f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309477f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
